import { render, staticRenderFns } from "./PrePostReports.vue?vue&type=template&id=324193a8&scoped=true"
import script from "./PrePostReports.vue?vue&type=script&lang=js"
export * from "./PrePostReports.vue?vue&type=script&lang=js"
import style0 from "./PrePostReports.vue?vue&type=style&index=0&id=324193a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324193a8",
  null
  
)

export default component.exports